import BigNumber from 'bignumber.js';

import {
  getChainIdByEnv,
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { getConnectedIotaProvider } from 'modules/auth';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { currentEnv } from 'modules/common';
import { KnownDialogs, openDialog } from 'modules/dialogs';

import { stake } from '../api/stake';
import { stakeCacheTags } from '../stakeCacheTags';

type Args = {
  amount: BigNumber.Value;
};

export const { useStakeMutation } = mainApi.injectEndpoints({
  endpoints: build => ({
    stake: build.mutation<void, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, { digest: string }>(
        async ({ amount }) => {
          const provider = getConnectedIotaProvider();
          const client = provider.getClient();

          const { digest } = await stake({
            chainId: getChainIdByEnv(currentEnv),
            wallet: provider.getWallet(),
            walletAccount: provider.getWalletAccount(),
            client,
            amount: new BigNumber(amount),
            env: currentEnv,
          });

          await client.waitForTransaction({ digest });

          return { data: { digest } };
        },
        error => getExtendedErrorText(error, 'Failed to stake'),
      ),
      async onQueryStarted({ amount }, { dispatch, queryFulfilled }) {
        await queryFulfilled;

        dispatch(
          openDialog({
            currentModal: KnownDialogs.successStake,
            amount: new BigNumber(amount),
          }),
        );
      },
      invalidatesTags: [
        ...Object.values(stakeCacheTags),
        authCacheTags.account,
      ],
    }),
  }),
});
